import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RectangleToolIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect x="5" y="6" width="14" height="12" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

RectangleToolIcon.displayName = 'RectangleToolIcon';
